import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./overview.module.scss";
import SummeryBlock from "./summaryBlock";
import ProjectDetailsComponent from "./projectDetails";
import ProjectCompaniesComponent from "./companies";
import ProjectMembersComponent from "./projectMembers";
import UpcomingTasksComponent from "./upcommingTasks";
import ProjectNextStepsComponent from "./projectNextSteps";
import ActivityComponent from "./activity";
import DocumentComponent from "./documents";
import { Discussion } from "../../../shared";
import FinancialsBox from "modules/projects/project/overview/financialsBox";
import ProjectsThemes from "modules/projects/project/overview/themes";
import RelatedIdeasComponent from "./ideas/index";
import FordMetrics from "modules/projects/project/overview/fordMetrics";
import FordPlants from "modules/projects/project/overview/fordPlants";
import ProjectRatings from "modules/projects/project/overview/ratings";
import ProjectReplications from "modules/projects/project/overview/replications";
import ProjectsSolutions from "./solutionsBox/index";
import RelatedProjects from "modules/projects/project/overview/relatedProjects";
import FordPossibleReplications from "../../../../common/components/FordPossibleReplications";

const OverviewComponent = ({ patientOrg, canManageTasks }) => {
  const { id } = useParams();
  const [isProjectMember, setIsProjectMember] = useState(null);

  const {
    authReducer: { session },
    projectsReducer: {
      projectReducer: { selectedProject },
    },
    councilReducer: { selectedCouncil },
  } = useSelector((state) => state);

  useEffect(() => {
    const member = selectedProject?.project_members.find(
      (m) => m?.user?.id || m?.external_project_member?.id === session.id
    );

    if (member) {
      setIsProjectMember(member);
    }
  }, [session, selectedProject]);

  const canManageReplications = useMemo(() => {
    if (session?.council_role !== 'ttp_administrator' && session?.council_role !== 'council_administrator') {
      return session?.spoc || session?.innovation_leader;
    }

    return canManageTasks;
  }, [canManageTasks, session]);

  return (
    <div className={styles.overviewWrp}>
      <div className="row">
        <div className="col-9">
          {selectedCouncil?.name === "Firmenich" &&
          selectedProject?.stage_template?.default_template ? null : (
            <SummeryBlock selectedCouncil={selectedCouncil} />
          )}
          {selectedCouncil?.name === "Kyndryl" && (
            <ProjectNextStepsComponent
              selectedProject={selectedProject}
              canManageTasks={canManageTasks || isProjectMember}
            />
          )}
          {selectedCouncil?.name === "Ford" && selectedProject && (
            <FordMetrics
              project={selectedProject}
              haveActions={
                canManageTasks || isProjectMember?.user?.id === session?.id
              }
            />
          )}
          <ProjectDetailsComponent canManageTasks={canManageTasks} />
          {selectedCouncil?.traction_tag === "firmenich" && selectedProject ? (
            <FinancialsBox
              project={selectedProject}
              haveActions={
                canManageTasks || isProjectMember?.user?.id === session?.id
              }
            />
          ) : null}
          <UpcomingTasksComponent canManageTasks={canManageTasks} />
          <DocumentComponent />
          <ActivityComponent />
        </div>
        <div className="col-3">
          {selectedCouncil?.name === "Ford" && selectedProject && (
            <>
              <FordPlants selectedCouncil={selectedCouncil} />
              {selectedProject?.replications?.length > 0 ||
              selectedProject?.original_project ? (
                <ProjectReplications project={selectedProject} />
              ) : null}
              <FordPossibleReplications data={selectedProject} canEdit={canManageReplications} instance="Project" />
            </>
          )}
          <ProjectCompaniesComponent patientOrg={patientOrg} selectedProject={selectedProject} />
          {selectedProject?.rating_enabled && (
            <ProjectRatings project={selectedProject} />
          )}
          <ProjectMembersComponent />
          <Discussion
            projectId={id}
            type="Project"
            reducerProp="projectDiscussions"
            isCurrentUserProjectMember={isProjectMember}
          />
          {
            selectedCouncil?.name === 'Ford' && (
              <RelatedProjects selectedProject={selectedProject} />
            )
          }
          {selectedCouncil?.themes_connected &&
            (selectedCouncil?.settings.theme_projects_enabled ||
              selectedCouncil?.settings.theme_projects_enabled ===
                undefined) && (
              <ProjectsThemes
                selectedProject={selectedProject}
                selectedCouncil={selectedCouncil}
              />
            )}
          {selectedCouncil?.settings?.solutions_connected && (
            <ProjectsSolutions
              selectedProject={selectedProject}
              selectedCouncil={selectedCouncil}
            />
          )}
          {selectedCouncil?.traction_tag !== "gsk" &&
            selectedCouncil?.settings?.ideas_connected !== false && (
              <RelatedIdeasComponent
                selectedProject={selectedProject}
                selectedCouncil={selectedCouncil}
              />
            )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(OverviewComponent);
